const Testimonials = ({ image, text, name }) => {
  return (
    <>
      <div className="col-lg-6 mb-3">
        <div className="testi-card">
          <div className="testi-icon mb-3">
            <img src="chat.png" alt="Quote icon" loading="lazy" />
          </div>
          <div className="testi-text">
            <p>{text}</p>
          </div>
          <div className="testi-buttom">
            <div className="testi-stars">
              <img src="/rating.png" alt="5 star rating" loading="lazy" />
            </div>
            <div className="testi-frame">
              <img src={image} alt={name || "Testimonial photo"} loading="lazy" />
              <span>{name}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Testimonials;
